import * as types from './types';

export const open = ({ commit }, modal) => {
  commit(types.MODAL_OPEN, modal);
};

export const close = ({ commit }) => {
  commit(types.MODAL_CLOSE);
};



// WEBPACK FOOTER //
// ./src/shared/components/modal/store/actions.js